import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AppLayoutHeader } from './header/header';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.html',
  styleUrl: './app-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, AppLayoutHeader],
})
export class AppLayout {
  readonly layoutService = inject(LayoutService);

  onSidebarToggle(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 1200) {
      this.layoutService.toggleCollapse();
    } else {
      this.layoutService.close();
    }
  }
}
